import React from 'react'
import { AgTechActionButton, AgTechLink } from '@agtech/web/components/Buttons/AgTechButtons'
import { SaleLot } from '@sales/data/lots/LotData'
import { SaleLotCategory, SaleLotCategoryIndex } from '@sales/data/lots/categories/LotCategoryData'
import LotDetailPopUp from '../popups/LotDetailPopUp'
import LotDialog from '../../dialogs/LotDialog'
import LotActionMenu from '../menus/LotActionMenu'
import LotCategoryActionMenu from '../menus/LotCategoryActionMenu'

export type LotActionButtonProps = {
    lot: SaleLot
}

export const LotActionButton = (props: LotActionButtonProps) => {
    return (
        <AgTechActionButton classes='stretched centered container'>
            <LotActionMenu lot={props.lot} />
        </AgTechActionButton>
    )
}

export const LotCategoryActionButton = (props: { lotCategory: SaleLotCategory }) => {
    return (
        <AgTechActionButton classes='stretched centered container'>
            <LotCategoryActionMenu category={props.lotCategory} />
        </AgTechActionButton>
    )
}

export type LotLinkProps = {
    lot: SaleLot,
    lotCategories: SaleLotCategoryIndex,
    classes?: string
}

export const LotLink = (props: LotLinkProps) => {
    const lot = props.lot;
    const lotCategory = lot.lotCategoryId ? props.lotCategories[lot.lotCategoryId] : undefined;

    return (
        <AgTechLink
            content={lot.lotNumber}
            body={() => lotCategory ? (
                <div className='row-based tall ml-auto mr-3 centered container'>
                    <div className='bordered' style={{ height: 14, width: 24, borderRadius: 2, backgroundColor: lotCategory.color }} />
                </div>
            ) : undefined}
            onClick={e => e.dialogs.openDialog({
                dialog: () => <LotDialog lotId={props.lot.id} />
            })}
            onHover={() => ({
                popup: () => (
                    <LotDetailPopUp
                        lot={props.lot}
                        lotCategories={props.lotCategories}
                    />
                ),
                config: {
                    topOffset: 24,
                    shouldCloseOthersOnOpen: true
                }})
            }
            classes={`!text-sm ${props.classes}`}
        />
    )
}